var $1b424c160db5642d$exports = {};
$1b424c160db5642d$exports = {
  "alert": "Ostrze\u017Cenie",
  "dismiss": "Zignoruj"
};
export { $1b424c160db5642d$exports as default };